import React from 'react';
import { useState, useEffect, useReducer } from 'react';
import axios from 'axios';

//import ReCAPTCHA from 'react-google-recaptcha';

import Product from '../custom_elements/Product';

// Access the global domain based on the environment
const backendUrl = process.env.REACT_APP_DOMAIN_BACKEND; // Get domain from environment variable
const domain = process.env.REACT_APP_DOMAIN_WORDPRESS; // Get domain from environment variable

const ContactForm = ({onBackClick, product, requestData}) => {

const my_product = product;

const {kreditbetrag, rate, laufzeit, sollzins, bag, fixlaufzeit} = product;
const {kaufpreis, eigenmittel, vorhaben} = requestData || {};
const [, forceUpdate] = useReducer(x => x + 1, 0);

const [formData, setFormData] = useState({
   name: '',
   vorname: '',
   email: '',
   mobil: '',
   message: '',
   datenschutz: false,
 });

const [isFormValid, setIsFormValid] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };



  //const [captchaToken, setCaptchaToken] = useState(null);
  //const [captchaVerified, setCaptchaVerified] = useState(false);
  const [cookieAccepted, setCookieAccepted] = useState(false);

{/*
  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
    verifyCaptcha(token);
};*/}
  const checkCookieValue = () => {
   return document.cookie
    .split("; ")
    .find((row) => row.startsWith("cookieAccept="))
    ?.split("=")[1];
  }
{/*
  useEffect(() => {
      if (captchaVerified) {
        validateForm();
      }
    }, [captchaVerified]);

  const verifyCaptcha = async (token) => {
    try {
      const response = await axios.post(`${backendUrl}/ajaxController.php?action=verifyCaptcha`, { token });
      const responseData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

      if (responseData.success) {
        setCaptchaVerified(true);
      } else {
        setCaptchaVerified(false);
      }
    } catch (error) {
      setCaptchaVerified(false);
    }
};*/}


    const formatEuroNumber = (value) => {
      return value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

  const handleAngebotClick = async () => {
      try {
        const referrer_id = localStorage.getItem('referrerId');
        formData.referrer_id = "";
        if (referrer_id) {
          formData.referrer_id = referrer_id;
        }
        const apiUrl = `${backendUrl}/ajaxController.php?action=sendAngebotMail`;
        const passedRequestData = {mailfrom: formData.email, mobil: formData.mobil, name: formData.name, vorname: formData.vorname, message: formData.message, kreditbetrag: formatEuroNumber(kreditbetrag), rate: formatEuroNumber(rate), laufzeit: laufzeit, sollzins:sollzins.toFixed(2), bag: bag.toFixed(2), fixlaufzeit: fixlaufzeit, kaufpreis: kaufpreis, eigenmittel: eigenmittel, vorhaben: vorhaben, referrer: formData.referrer_id};

        const response = await axios.post(apiUrl, passedRequestData);
        if (response.data) {
          alert("Vielen Dank! Deine Anfrage wurde erfolgreich übermittelt. Wir melden uns in Kürze bei dir!");
        } else {
          alert("Es ist ein Fehler aufgetreten, bitte kontaktieren Sie den Support.");
        }
      } catch (error) {
         alert("Es ist ein Fehler aufgetreten, bitte kontaktieren Sie den Support.");
      }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFormValid) {
      // Submit form logic here
    } else {
      alert('Bitte geben Sie ihren Namen und E-Mail ein, und stimmen sie den Datenschutzbestimmungen zu.');
    }
  };

  const validateForm = () => {
    const { name, vorname, email, mobil, datenschutz } = formData;

    if (name && vorname && email && mobil && datenschutz) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
    forceUpdate();
  };

  checkCookieValue();
  React.useEffect(() => {
    validateForm();
  }, [formData]);


  React.useEffect(() => {
    const interval = setInterval(() => {
      setCookieAccepted(checkCookieValue() == 1);
    }, 1000);
  }, []);

  const handleBackClick = () => {
    onBackClick();
  }
  return (
    <div className="card">
    <div className="container" style={{padding: '40px'}}>
      <div className="card-body">
        <div className="row" style={{paddingBottom: '40px'}}>
            <h3>Kontaktieren Sie uns für ein erstes Beratungsgespräch zu Ihrem Angebot!</h3>
        </div>
        <div className="row">
            <div className="col-md-5">
            {/* Your contact form elements (input fields, submit button, etc.) */}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Vorname *"
                  name="vorname"
                  value={formData.vorname}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nachname *"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email *"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Mobil *"
                  name="mobil"
                  value={formData.mobil}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <textarea
                  className="form-control"
                  placeholder="Message"
                  name="message"
                  onChange={handleChange}
                />
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="datenschutz"
                  name="datenschutz"
                  checked={formData.datenschutz}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="datenschutz">
                  Ich stimme den <a target="_blank" href={`${domain}/datenschutz`}>Datenschutzbestimmungen</a> zu.
                </label><br /><br />
              </div>
              {/*
                {cookieAccepted &&
                <ReCAPTCHA
                  sitekey="6LdsyikUAAAAANV-HhJWw-5d1dc6k9eQkrCFbtvr"
                  onChange={handleCaptchaChange}
                />
                }
                */}
                <br></br>
              <button onClick={() => handleBackClick()} className="btn btn-secondary btn-showmore">ZURÜCK</button>
              <button type="submit" onClick={() => handleAngebotClick()} className="btn btn-secondary btn-contact" disabled={!isFormValid}>SEND</button>
            </form>
            </div>
            <div className="col-md-7">
                <Product product={my_product} isContactForm={true}/>
            </div>
          </div>
      </div>
  </div>
</div>
  );
};

export default ContactForm;
